// Skills Configuration
// Update this file to modify your skills and technologies

import { 
  SiJavascript, 
  SiTypescript, 
  SiPython, 
  SiSolidity,
  SiReact,
  SiNextdotjs,
  SiRedux,
  SiTailwindcss,
  SiMaterialdesign,
  SiNodedotjs,
  SiExpress,
  SiNestjs,
  SiMongodb,
  SiPostgresql,
  SiRedis,
  SiAmazon,
  SiDocker,
  SiKubernetes,
  SiGithubactions,
  SiSocketdotio,
  SiGraphql,
  SiJest,
  SiGit,
  SiJira,
  SiPostman,
  SiWeb3Dotjs,
  SiEthereum,
  SiAndroid,
  SiFirebase
} from 'react-icons/si';

export const skillsData = {
  languages: [
    { name: "JavaScript", icon: SiJavascript, color: "text-yellow-500" },
    { name: "TypeScript", icon: SiTypescript, color: "text-blue-600" },
    { name: "Python", icon: SiPython, color: "text-blue-500" },
    { name: "Solidity", icon: SiSolidity, color: "text-gray-600" }
  ],
  
  frontend: [
    { name: "React", icon: SiReact, color: "text-cyan-500" },
    { name: "Next.js", icon: SiNextdotjs, color: "text-black dark:text-white" },
    { name: "Redux", icon: SiRedux, color: "text-purple-600" },
    { name: "React Router", icon: SiReact, color: "text-red-500" },
    { name: "Tailwind CSS", icon: SiTailwindcss, color: "text-teal-500" },
    { name: "Material-UI", icon: SiMaterialdesign, color: "text-blue-500" }
  ],
  
  backend: [
    { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" },
    { name: "Express", icon: SiExpress, color: "text-gray-600" },
    { name: "NestJS", icon: SiNestjs, color: "text-red-600" },
    { name: "Socket.io", icon: SiSocketdotio, color: "text-gray-900 dark:text-white" },
    { name: "GraphQL", icon: SiGraphql, color: "text-pink-600" },
    { name: "RESTful APIs", icon: SiNodedotjs, color: "text-green-500" }
  ],
  
  database: [
    { name: "MongoDB", icon: SiMongodb, color: "text-green-600" },
    { name: "PostgreSQL", icon: SiPostgresql, color: "text-blue-600" },
    { name: "Redis", icon: SiRedis, color: "text-red-600" },
    { name: "Firebase", icon: SiFirebase, color: "text-yellow-500" }
  ],
  
  mobile: [
    { name: "React Native", icon: SiReact, color: "text-cyan-500" },
    { name: "Android", icon: SiAndroid, color: "text-green-500" },
    { name: "Expo", icon: SiReact, color: "text-blue-600" }
  ],
  
  devops: [
    { name: "AWS", icon: SiAmazon, color: "text-orange-500" },
    { name: "Docker", icon: SiDocker, color: "text-blue-500" },
    { name: "Kubernetes", icon: SiKubernetes, color: "text-blue-600" },
    { name: "CI/CD", icon: SiGithubactions, color: "text-gray-900 dark:text-white" }
  ],
  
  tools: [
    { name: "Git", icon: SiGit, color: "text-orange-600" },
    { name: "GitHub", icon: SiGithubactions, color: "text-gray-900 dark:text-white" },
    { name: "Jest", icon: SiJest, color: "text-red-600" },
    { name: "Postman", icon: SiPostman, color: "text-orange-500" },
    { name: "Jira", icon: SiJira, color: "text-blue-600" }
  ],
  
  emerging: [
    { name: "Web3.js", icon: SiWeb3Dotjs, color: "text-orange-500" },
    { name: "Ethereum", icon: SiEthereum, color: "text-gray-700 dark:text-gray-300" },
    { name: "Smart Contracts", icon: SiSolidity, color: "text-gray-600" }
  ]
};

export default skillsData;
